import { Controller } from "@hotwired/stimulus"
import { formatGeneral } from 'cleave-zen'

// Connects to data-controller="zip"
export default class extends Controller {
  static targets = [ "input" ]

  connect() {
    this.inputTarget.addEventListener('input', (e) => {
      this.inputTarget.value = formatGeneral(e.target.value, {
        blocks: [5],
        numericOnly: true
      })
    })
  }
}
